import React from 'react';
import styled from '@emotion/styled';

import Text from '@/components/Text';

const StyledText = styled(Text)`
  text-transform: uppercase;
`;

const OvernightBadge = () => (
  <StyledText
    bold
    fontSize="xxs"
    lineHeight="16px"
    bg="background.warning"
    ml={2}
    py={1}
    px={2}
  >
    Overnight
  </StyledText>
);

export default OvernightBadge;
